module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("DEDICATION")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("HIS BOOK SERIES IS")]), _vm._v(" dedicated to all the nameless volunteer blood donors, my doctor, and nurses at Las Colinas Medical Center in Texas who helped me pull through when I had suffered extreme blood loss, blacked out, and nearly hit my head on the floor. Your team gave me bags of blood for transfusion, which helped restore me to a level of safety.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My body craved the blood to keep alive, yet the thought of having to receive the blood from others because my own body couldn't generate it fast enough, made me empathize with vampires like Jaegar and Stuart.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When faced with death by blood loss, you realize how precious that blood in your veins and that beat in your heart are. Thank you blood donors around the world for providing this pulse for me and everyone who may at one point or another require your gift.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sincerely,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kailin")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")])])]), _vm._v("he sun had gone here. It wasn’t like it was back home – the harsh yellow light of California, with its bracing blaze. Here, the sun was softer, if it existed at all, peeking out shyly from behind the fat, white clouds. The breeze was fresh and cool; Kalina could smell pine and fir, the sticky-needle smell of the East Coast. It was peaceful, she thought. Different. This was not Californian heat, Californian sun – the scorching sweaty heat she associated with the vineyards, with Jaegar, with the musky smell – as warm and sweet and dark as chocolate – of Vampire Wine. No, this place was cool, quiet, safe. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And if you come with me,” the tour guide was saying, “you’ll be able to see Connecticut Hall, the oldest building on campus. Built between 1750 and 1753...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1750 and 1753.")]), _vm._v(" Once, those numbers would have seemed so arbitrary, historical numbers picked out of a hat, meaningless labels from a time long ago. But now Kalina found herself wondering against herself – where was Stuart in 1753? How about Jaegar? Octavius? Were they here in America, to see it being built? Or were they in Europe, in foreign lands, in fetid deserts or shivering tundras...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Concentrate, Kalina")]), _vm._v(", she whispered to herself, biting her lip. Touring Yale, leaving California behind, was supposed to help her forget. It was supposed to clear her head – the cool New England weather taking the place of the heat and sweat and madness of Rutherford, of the vineyard. But as the tour guide kept talking, pointing out each new building, each prestigious statue, all she could think was "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("does Jaegar know this building? Did Stuart meet this man? Was Octavius here when this was built?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The other students on the tour were giggling and whispering with each other; a few dedicated ones were taking down notes, scribbling every detail of every date as if it were to be the subject of their first test. For them, Yale was the culmination of a life’s dream and a life’s work; twelve years of school, SAT scores, perfect grades, and hastily attained accolades. And now they had been accepted, and Kalina could see the fulfillment, the joy, on all of their faces, the feeling that entering Yale’s campus was, for them, like entering the next stage of their lives—fresh with possibility, with opportunity, with adventure.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A year ago, Kalina thought, she had felt like that too. Her quest to get into a good college, to be "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the best")]), _vm._v(", had been the most important thing in the world to her. She had spent hours in the library to inch up her grades by a tenth of a point; she had spent hours in the gym toning her figure for cheerleading with the hopes of obtaining an athletic scholarship. Had somebody told her that in a year’s time she’d be accepted into Yale, and unable to feel anything, she would have laughed in their face.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But here she was, staring enviously at the other students, angry at them – against herself – because they could be so happy, so excited. They were on the verge of the greatest adventure in their lives.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina had already lived through hers. She’d discovered her Life’s Blood, that strange quality that had made her irresistible to vampires, and yet had drawn her in equal measure towards their world, their passions and desires. She’d fallen in love – with a dream, with a memory, with four vampires whose blood-bond with each other had called her to each of them in turn – and known fear, known death.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Did you hear that?” Justin whispered. “You can take up Tibetan Pali here! Wouldn’t that be great! Mom always wanted you to be familiar with your culture...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But she could only manage a nod before turning away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She would never be free, she knew; she would never be truly safe. But the only thing she could do was try to move on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where’s the dining hall?” one student asked with a tremulous grin.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The tour guide smiled back. “Right this way,” she said – “if you’ll just come with me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The dark, neo-Gothic buildings jutted above them – spires and gargoyles casting shadows on the gravel path. Kalina could have smiled. This is where you’d expect to find vampires, she thought to herself, not in the bright, terracotta-roofed houses of Rutherford, California, with its sun, its shine, its sea.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The sun had begun to set, and the tour guide hastily ushered them through an archway.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The a capella group does a lot of singing here,” she started. “It’s a Yale tradition. Sometimes...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But her monologue was interrupted by a scream – a piercing sound that tore through the evening air like a lightning bolt. Kalina felt her heart stop. She knew that scream, that sound. She’d heard it before – too many times – in Rutherford, a scream of fear, confusion, and utter terror: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what is that thing?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They had all started rushing to the source of the sound – the tour guide, the students, instinctively running towards one of the more secluded quads. There, lying upon the grass, was a young woman, her Yale sweatshirt stained with blood, two gaping holes in her neck...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stuart. ")]), _vm._v("Kalina felt it before her conscious mind had processed the information. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("No sooner had the thought struck her than she heard that same, familiar voice in her head – once so soft, so sweet and lilting, now filled with mocking hate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kalina")]), _vm._v(". The voice laughed. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I’ve come to claim you, my love.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She whipped her head around, looking frantically – past the girl, who was being attended to by a growing crowd of students, past the others on the tour, who were shifting uncomfortably in their sneakers, searching for something in the sky, in the air, in the shadows...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Nobody was there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It had been a month since Kalina had last seen him, and in that month the days had dragged on and the nights had seemed endless. She had gone into hiding for a while, but in the end she returned to Rutherford to face him, to face Mal – hoping that the same magic she had exerted on Jaegar, saving him from the curse of the Life’s Blood, would work on his brother too. She hoped that she would be able to save him. But he was gone – along with Mal – and there was nothing she could do but wait, wait for him to come back, to decide he was ready to claim her for his own...and fight him every step of the way.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina had always known he would come back. But she didn’t think it would be here at Yale. She hoped that this would be her chance at starting over, at trying to have a normal life – buying time before Stuart returned.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("See you soon, Kalina. ")]), _vm._v("His voice was right there with her, whispering into her ear, burning into her brain; she shuddered at the thought.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("You’re not safe here, my love. You’re not safe anywhere.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And then she sensed that he had vanished; her muscles relaxed. He was gone, fled the area – for now. But he’d come back, she knew it. He’d find her when she least expected it, pin her down, sink his teeth into her, let go at last of all his propriety, his self-restraint, and do what he wanted.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina felt uneasy, even sick...that Stuart could so easily invade her thoughts with his threats. He could work his way into her mind drawing upon the connection they’d shared before he was turned. He could invade her brain, her thoughts.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She wanted to curl up, to scrub her skin clean in the shower, hide under the covers of her room at the New Haven Inn, lock the door, sprinkle the sheets with holy water.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But that would be running, it would be hiding.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She reached into her bag, fingering the stake that she’d kept there, just in case, feeling its sharp edge prick against her fingers.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("So, she’d need it after all.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-j"
  }, [_vm._v("J")])])]), _vm._v("ustin came running up to Kalina, his face shiny with sweat. “What’s going on?” His voice was hoarse and raw.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Stuart’s back.” The words seemed to come from a place far away, far from Kalina – her feelings, her thoughts. “He’s come for me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” Justin shuddered. “After all this...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll handle it,” Kalina said quickly. “Don’t worry. I’ve stopped one turned vampire; I can stop another.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But Kal...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before Justin could finish, a loud "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ping")]), _vm._v(" interrupted their conversation. It was coming from Justin’s pager.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The hospital wants you,” said Kalina. “You don’t want to let them down on your first week.” Justin had arranged for a transfer for a few weeks at medical school in New Haven while Kalina was going through her Yale visit and apartment-hunting. If everything worked out, he would transfer permanently to New Haven when Kalina started school in the fall. His version of the story was that New Haven had a better hematology program, but Kalina was sure that professional development had very little to do with it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I can’t leave you!” Justin sighed. “What kind of brother would I be if I did that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A fired brother,” said Kalina. She knew Justin just wanted to protect her, but his presence here was cloying, even suffocating. She needed time and space to think, to process what was happening to her. And if there were any dangers lurking, it was much more likely that she’d need to save Justin rather than the other way around. He had warily accepted the presence of vampires, but even now her brother was shaky with a stake. “Listen, Justin, I want you to take it, okay? I want you to go. I’ll meet you after; I promise. Just text me when you’re done. I’ll go back to the New Haven Inn and take it from there. I promise – no vampires. I’ll be back before the sun goes completely if I leave now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin scrunched up his face, trying to decide what to do next. “Fine,” he said at last, letting out a deep sigh. “But if anything happens to you...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It won’t be your fault,” said Kalina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When Justin had finally gone, kissing and hugging her and reminding her at least ten times to text him when she had arrived safely at the hotel, Kalina breathed a sigh of relief. It was easier without him, to rest calmly, alone with her thoughts. Alone, she could think back to the events of the past few months – the transformation of Jaegar, what had happened to Aaron, Stuart’s turning – without having to hide her pain and grief, without having to stay strong for Justin’s sake.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina felt tears sting at the corners of her eyes. It was Stuart who had taught her how to defend herself against vampires, using whatever advantage her Life’s Blood had given her. Now she would have to use everything, every defense, every offense against Stuart himself, her tutor, her love. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She felt a chill. Probably just the New England wind, she told herself. She walked through the campus – already slowly returning to normal, the injured girl already wheeled away in an ambulance, the excuses seeping through campus like spilled wine (it was alcohol poisoning; she had a bad trip on acid and attacked herself; her boyfriend had a bad trip on acid and attacked her). Boys and girls her own age were playing Frisbee on the quad, warm inside their college hoodies. Through the windows of the library she could see other students, students just like her, hunched over their books, making notes on neatly lined paper, chewing the ends of their pens and pencils just like she did, getting ink on their lips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("This wasn’t for her, Kalina thought; she had been stupid to pretend otherwise. Even if she managed to somehow live through matriculation, Kalina’s life would never be like theirs. She’d never get to sit through a history class on the Renaissance, not without thinking of Octavius and their night together in Paris, and of their adventures on the moonlit streets of Rome. She’d never listen to a debate on whether the supernatural existed – a raucous argument in a science class, perhaps– without feeling that somehow she knew the answer, she "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("knew ")]), _vm._v("the strangeness of what was out there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She would never be like them again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("By the time Kalina reached the New Haven Inn, the sky had gone completely dark. She fingered her crucifix as she picked up her keys from the front desk, eliciting a curious look from the concierge, and entered the room. She felt the same familiar chill that came now anytime she entered a new place – the same fear – but a quick check of all the closets and corners assured her safety for now. She double-locked the door, closed the shutters, and curled up in the middle of the bed, willing herself to fall asleep, to give her mind over to the exhaustion that had been tapping at the back of her consciousness all day.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I will find you")]), _vm._v(" – Stuart’s voice still echoed in her head, and she couldn’t tell whether or not it was only a memory – "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I will take you, Kalina.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Stuart’s voice, so soft now, but so cruel and cold and calculating, carried her into a dreamless slumber.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When the telephone rang, Kalina’s eyes flew open, her exhaustion extinguished by adrenaline.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Everything okay?” she muttered as she picked up the phone. Any call now, she knew, could be the news that she most dreaded hearing. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was Justin. “I’m fine,” he said. “Are you?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fine – for now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Listen,” said Justin. “Can you get to the hospital? Like – tonight?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What’s going on?” Kalina sat straight up. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Something’s happened...” Justin’s voice was hollow. “Get a cab; I’ll pay for it. Have the hotel order you a taxi – can you do that?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina eyed her stake. “Sure.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll see you here soon.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And without even saying goodbye, Justin had hung up; the phone silent and dead. Kalina sighed as she threw it in her purse. She didn’t even want to think about what emergency could be on the horizon now – another murder, another abduction, another thing to blame on her. Every death was on her now, Kalina thought – the longer she waited before facing Stuart; the more people would die in the meanwhile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The half-hour it took to get to the hospital seemed like forever. Every step was fraught with terror – leaving her room, entering the taxi (was the driver safe? Did he look suspicious?), the long drive down secluded alleyways, Stuart’s voice whispering in her ear the whole while.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("I’ll get you soon Kalina. When you least expect it. And you won’t be able to stop me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When Kalina entered the hospital lobby and caught a glimpse of herself in the mirror, she stopped short. Fear had turned her skin so pale she looked unearthly; her eyes were red-rimmed and bloodshot; her lips were drained of color. Was this what Stuart had done to her? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A wave of righteous anger rose up within her. Stuart was getting to her – she was "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("letting him ")]), _vm._v("get to her. She couldn’t let him continue.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before she could finish her thoughts, Justin came running into the lobby, still wearing his hospital scrubs. “So glad you’re here!” Justin enveloped her in a hug. “I’ve been waiting – worried...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We hit some traffic,” said Kalina.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Listen,” Justin sighed. “You might want to sit down for this.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Another vampire victim?” Kalina sat, settling into a splendidly uncomfortable hospital chair. “I can take it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not a vampire victim,” said Justin. “Just – a normal junkie we picked up off the streets. At least – that’s what I thought at first.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I overheard the others talking – Dr. Smoots, he’s the head hematologist—was saying it was like nothing he’d ever seen before. There was something strange about this girl, about her blood. It didn’t...fit.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina felt a familiar chill – she only knew of one other case that has caused such confusion with doctors. Hers. Her own blood – the Life’s Blood coursing through her – began to prickle and heat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin sighed. “And then I saw her – unconscious, lying on the bed, but I could see her face.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay?” Kalina couldn’t breathe; the prickling in her blood was getting stronger, rising, rising to a boil. “I don’t get it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She looked like you, Kalina!” Justin spit out the words in a single, breathless sentence. “Just like you. The resemblance – not just like a cousin, or even a sister. Like a twin. Older, maybe – and more beat-up; she looked like hell. But it was...it was like I was looking at you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina shuddered, as what felt like a bolt of electricity pulsed through her, rushing through her body, burning up her veins. She had felt similar things in the past, when her blood had connected with Jaegar’s, with Octavius’. But she’d never felt anything like this. Her whole body was shaking, trembling from the jolt.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Life’s Blood. She knew it with the truth of blood-certainty.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where’s the girl now?” Kalina forced out the words.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Gone,” Justin said. “Dr. Smoots called me into his office – I tried to get away, but by the time I made my way out of there she’d just...gone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She must have left not too long ago, because the air around Kalina, especially down the hallway, which the girl had most likely traveled down minutes before, made her blood burned, and she could feel blood rush through her face causing her to flush pink.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hey, you okay?” Justin asked.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” Kalina said, steadying herself. She had never felt this sensation before, not with Octavius, Stuart, Jaegar, and even Aaron. “Even after she’s gone, I could still feel her presence here.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin and Kalina looked at each other.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Life’s Blood was that strong, and now Kalina knew how vampires felt around her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But who was this girl?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-j"
  }, [_vm._v("J")])])]), _vm._v("ustin and Kalina returned to the hotel in silence. She knew what he was thinking, knew that Justin was wondering – just as she was – about the identity of the mysterious girl in the hospital bed. Justin’s story had unsettled her enough – the idea of a twin, a look-a-like, in the very same building – but what had truly thrown her was the sensation that had entered into her blood, the burning surety that she was in the presence of Life’s Blood, not her own, but that of another, a stranger. Kalina knew that the Life’s Blood within her was strong; it recognized its own, just as it had recognized its desire and love in Octavius and the Greystone brothers. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("At last, when they had locked themselves safely in the hotel room, drawn all the curtains and closed all the shutters, and checked every last corner for danger, they sat down across from each other on the bed, and tried to make sense of it all.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You don’t think...” and Kalina said the question she knew they had both been thinking, “the orphanage, you know. Maybe they didn’t keep good records? Or maybe there wasn’t another one, at the orphanage...but my parents...my birth parents.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You think you have a sister?” Justin sighed. “You think..."), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _vm._v("have another sister?” He laughed lightly, the shock finally hitting him. “I mean, that’s crazy. But – then again – what "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("isn’t ")]), _vm._v("crazy when it comes to you, Kalina?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina shot him a soft smile. “I know,” she said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin inhaled. “Mom and Dad always told me that you were the only one,” he said, “that you had no known family anywhere in the world. They would have told me if there had been another sibling in the orphanage; the orphanage couldn’t have known...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But that doesn’t mean there wasn’t one,” said Kalina. What was the alternative, then? That there had been another daughter, one who had never made it to an orphanage? One that her biological parents had been able to keep? She had always imagined that her parents were dead; what if they had only abandoned her? She wasn’t sure of anything anymore.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Listen,” said Justin. “Kalina, I did something, okay? I did something that – well, let’s just say that if anyone finds out about this, I could lose my job. So, don’t tell anyone, okay?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course,” said Kalina, as Justin withdrew a thin manila folder from his briefcase. He handed them to her, his face stony and expressionless.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stole her medical records?")]), _vm._v("” Kalina almost shouted. This was so unlike quiet, rule-abiding Justin; she could have laughed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It was important,” said Justin, somewhat sheepishly. “If it involves you, and your life – well, I’m making it my business.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina couldn’t help but smile. Shy, over-protective or not, Justin was the best older brother any girl could ask for. As a thin crimson blush spread over Justin’s cheeks, Kalina considered him thoughtfully, running her eyes up and down the length of his face. He was handsome, even in his awkwardness, his stiff, shy way of being embarrassed about doing the right thing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You need a girlfriend,” Kalina decided.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” Justin’s eyes grew large. “Where did that come from?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I need someone to distract you,” she said. “From worrying about me. To let you live your life – without risking your job. I can take care of myself. I’ve got the help of others – people like Jaegar...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Live my life?” Justin sighed. “This "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _vm._v("my life, Kalina. I’m your brother, your guardian. Caring for you is my life.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That doesn’t mean...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Besides,” he continued, “I’ve got work.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There are lots of cute nurses and doctors in the hospital,” said Kalina. “I’m sure a smart guy like you could find something.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin turned bright red, muttering something under his breath.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who’s to say I haven’t?” said Justin, a little louder this time.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What?” Kalina jumped up. “What? And you didn’t tell me!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve been looking around,” said Justin. “Over the summer – you know – keeping things casual. Seeing a few young ladies, here and there.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A few?” Kalina raised an eyebrow. “Do they know about each other?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They know I’m keeping things casual – for now. I’ve got too many responsibilities to be in a relationship.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So, you’re willing to leave all these women in Rutherford to take care of me at Yale? I don’t know, Justin – not the best trade.” It was good to laugh with her brother again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But Justin grew serious. “Listen, Kal,” said Justin, “I promised Mom and Dad I’d take care of you. Because you’re special. Everything about you – from the necklace they found on you when you were a baby to the weirdness in your blood charts. I don’t know what they knew...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“They knew about vampires? You think they knew all that and didn’t tell me? Tell us?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I don’t know what they knew,” said Justin again. “I’ve been rereading Mom’s journal, since we came out to New Haven. And in one of the entries around the time they adopted you, Mom talks about you being the “key to end it.” I don’t know what it means, but I have to find out, to know as much as possible. You’re my sister, my only family. If anything happened to you,” he sighed, “I’d have no one.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina enveloped him in a hug, wrapping her arms tightly around his shoulders. “Don’t worry,” said Kalina. “I can take care of myself. But you, you’re the one I’m worried about.” She let out a deep sigh. “You need to take care of yourself, too. This Life’s Blood; it gives me powers. But you....if they wanted to get to me, any of them, all they’d have to do is find you, take you – and I’d do anything to protect you, to save your life. You know that. They know that. So please, be careful. For your sake – and for mine.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin smiled. “Look, I may not be a vampire like your boyfriends... ex-boyfriends...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ex-boyfriends,” said Kalina, quickly. As far as she was concerned, she – like her brother – wanted to keep things casual. Her responsibilities were too great for her to be tied down, to vampires or humans, despite the fevered dreams that kept her turning at night.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But I’m pretty handy with a stake, okay?” Justin grabbed one from the bedside table. “See, I’ve been practicing. And I’ve been working out at the gym.” He showed her a couple of moves that she had taught him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina laughed. He wasn’t bad, after all, she thought, watching him make his quick, mechanically-trained movements. He was a smart boy after all, she thought, like her parents – his biological parents – as bright as they were. But were they bright enough to have figured out the secret of Life’s Blood.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Justin,” Kalina said softly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Can I see Mom’s journal? I mean, would you mind?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Justin stirred. “Of course,” he said. “It’s as much yours as it is mine, now.” He went to his suitcase, taking out a thin leather-bound volume. “This covers the years right after your adoption,” he said. “There are other volumes in the suitcase.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Must be heavy, lugging all those suitcases around.” They’d been going from hotel to hotel over the past few weeks as Justin searched for a more permanent apartment in the area, within easy walking distance to the Yale campus.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s a reminder,” said Justin, “of the bigger burden I carry.” He blushed again. “Always to take care of my little sister.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina smiled. “Thanks,” she said, squeezing his hand, before giving him an enormous hug, holding him tightly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A knock sounded at the door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They stiffened immediately, straightening up from the embrace. Justin tightened his grip on his stake; Kalina took another from her purse. She placed the journal under the tightly-wrapped covers of the bed and walked to the peep-hole.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll...” Justin began, rising.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” Kalina made it clear that she would not be moved on this point.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She peered through the peep-hole and then gasped, before laughing with relief.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who is it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But before Justin could finish his words Kalina was fumbling with the lock, opening the door, allowing herself to fall into Jaegar’s arms, feeling his lips hot on her own, his arms cool against her flesh. She stepped back as he kissed her more and more vigorously, tightening his grip on her, allowing herself to respond, slowly, at first, and then with the full flower of her desire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She almost didn’t hear as Justin muttered an excuse about the hotel bar and mealtimes, seizing the manila folder and stumbling out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where’s Justin?” she murmured, about five minutes after he had gone. Five minutes in which she had been delirious with happiness, with safety, with the feeling of bliss that meant being in Jaegar’s arms.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He went to have dinner!” Jaegar laughed, whispering into her ear and tickling her earlobes with his lips. “Didn’t you hear him?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No!” Kalina couldn’t help laughing too. Everything seemed so much better, so much safer and more certain, now that Jaegar was here.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hungry?” asked Kalina. “After all, you can eat food now...maybe we could get burgers?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hungry, yes!” Jaegar said, nudging her neck, bringing his lips to her cheek, her forehead, her eyes and lips. “I’m starving...” He picked her up and pushed her down onto the bed. “For you.” He trailed his kisses up and down the length of her body, ending with her lips. She inhaled the scent of him: warm, delirious, intoxicating.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Did I tell you,” murmured Jaegar, as his mouth found the hidden corners of her body, nudging up against her clothing, “just how delicious you are to me?” He laughed. “Even without my bloodlust, I still want you so much – just smelling you, getting close to you, gets me so...I can’t stop thinking about how much I want you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jaegar,” she kicked off her shoes, helped him unbutton his shirt. “What is it about you that...” But before she could finish, Jaegar had removed her blouse, and was working on loosening the hooks of her bra. “It’s only been a few days – but it seems like weeks.” She missed his touch, his caress, the lightness of his fingers; together they fell into each other’s arms, until at last they had both stripped to their underwear. She felt her fingers hot upon his back; she felt his arms so tight around her ribs. She could feel his urgency, his desire. She knew that he wanted to go further, wanted to give in at last to the desire that all but consumed them both.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She had nothing to fear, after all. Now that Jaegar had been turned human, her Life’s Blood could no longer corrupt him. And it was her love, wasn’t it, that had made him human? Surely that meant she was free at last, free to give herself up to him, to give in to what they both wanted so deeply.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She could see the love in his eyes, shining out with such intensity that they seemed to contain all the love in the world. “I swear,” Jaegar was whispering, “I love you so much, Kalina. You’re my woman...and I waited so long for this...I’ve waited for centuries to find you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina closed her eyes and lay back upon the pillow, waiting for surrender, for the sweet consummation of her desires.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jaegar,” she allowed her eyelids to flutter open. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What she saw shocked her. She stopped, mid-sentence, and shot up straight, her hand clapped tightly over her mouth.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jaegar had fangs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote"
  }, [_vm._v("“")])]), _c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-in-scene"
  }, [_vm._v("N")])]), _vm._v("o! No!” Kalina cried. “No, it can’t be.” She’d seen Jaegar turned human right in front of her, seen his fangs retract and his face fill with color, heard the beating of his heart and felt the softness of his breath upon her cheeks. She’d seen Jaegar become human; she’d watched it happen, her Life’s Blood restoring him to true health, although he had the speed of a vampire, a benefit of Life’s Blood. But at least he was human. And now here he was again, fangs intact.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Memories, images rushed through her of the short time they’ve been together just now. He hadn’t eaten; his skin was so cold – she hadn’t noticed a heartbeat. All things she had ignored in the heat of the moment, but which came back to her at once. So, Jaegar had been a vampire this whole time, as they had kissed, taken off each other’s clothes, come so close to...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She had hoped that it would be safe; she could be with him, as a human, doing what she could never risk doing with a vampire.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s okay, Kalina,” Jaegar was comforting her, wrapping her in his arms – so cold, now! Why hadn’t she noticed the cold before? “So it didn’t work. I guess the reversal was only temporary, or something.” He looked down. “It’s never happened before, that a Life’s Blood carrier has been able to do what you’ve done, fall in love with more than one...” He sighed and bit his lip. “Maybe it’s better this way,” he said. “I can protect you like this, protect Justin, in a way I never could if I were human. I had my chance to experience what it was like to be human for the first time in seven hundred years, even if it was only for a few days. And yes, it’s true, I loved it. But not because I was human, Kalina. But because I was with you, because I could be with you without being afraid of my bloodlust. I want to be with you, human or not. I only want you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina felt plump tears rolling down her cheeks. She consciously knew that there was nothing she could have done, but she still felt nevertheless like she had failed him, like somehow her love wasn’t truly strong enough to save him. Perhaps Jaegar was right – her feelings for Stuart and Octavius complicated matters, and maybe that was the reason behind Jaegar’s transformation back into a vampire: the failure of her love. “But I do love you,” Kalina murmured, “I do!”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jaegar pulled her into his arms, holding her tight. “I know, darling,” he whispered, “I know.” He sighed, giving a little laugh as he did so. “There’s the irony, I suppose. No matter how much we love each other, the universe may never allow us to, ah... be together.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He curled up in the bed beside her, his cold skin against hers. She felt his body grow tight against her and listened for a heartbeat, feeling only emptiness against his chest. Her desire had cooled now, as the moment had passed, but in its place she felt a soft, loving warmth; she wanted nothing more than to let him hold her in his arms, feel his smooth caress on her hair.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She turned over, looking straight into Jaegar’s eyes. She could see the tears standing at the corners of his gaze, blood-streaked tears that were slowly beginning to roll down his cheeks. She wanted to kiss them away, kiss his eyelids, his forehead, his cheeks. “I’m sorry, Jaegar,” she whispered. “I want to forget everyone else...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Octavius,” said Jaegar, darkly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Octavius, yes,” said Kalina, “and Stuart. I know Octavius gave me up – that it was impossible – he wanted me to forget him and I have, in part. But Stuart...I keep thinking it’s my fault that he’s been turned.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mal turned me before he turned Stuart,” said Jaegar. “And you were able to get me back from the brink.” She could feel him swallow his jealousy. “Maybe you could do the same for him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“If I offer him my blood,” Kalina whispered, “willingly, with love – instead of him forcing it from me. Maybe it would save him, somehow...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Or maybe he’d just kill you!” Jaegar cut in. “Look, I know what he’s feeling, what he must be going through right now. I’ve been there. The madness. I’m surprised he’s lasted this long, that he hasn’t given into his desire yet, tracked you down already.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“He’s here,” said Kalina. “I heard him, telepathically. He attacked a student on the Yale campus today. I tried to find him, but he was gone. He claimed me – in his words – whispered in my ear that I was his. He’s trying to torment me, to scare me, like a cat playing with a mouse. Still so polite, you know? Still sounds like the same old Stuart.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Only...bad.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Still so in control.” Kalina sighed, letting Jaegar hold her even closer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s what is scary,” said Jaegar. “That control is just a dam waiting to burst.” He lifted her chin lightly, looking deep into her eyes. “Kalina, I’ve already lost the only other people I love. I’ve already lost Aaron. I can’t lose you too. And if I lose you to Stuart – then I know I’ll lose you both. Everyone I love – gone, dead. You can’t sacrifice yourself like that, Kalina. You can’t risk it.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But what if...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t go to him, Kalina!” Jaegar’s voice grew more and more urgent. “I’ve never wanted anything more than this – to keep you safe. To keep you with me. I’ll fight him if I have to. But I won’t let him hurt you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, not yet,” said Kalina. “Don’t fight him. He hasn’t come for me yet – he’s biding his time for some reason, waiting.” She squeezed his hand. “We need to worry about a defense, about keeping the people I love safe in case Stuart – or Mal – shows up. Justin or Maeve – what about them? Mal could use them to get to me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Octavius is taking care of Mal,” said Jaegar. “They’re the two strongest vampires – they have the oldest feud. Octavius will do what he can. And considering all that Mal’s done – destroying the Consortium, all Octavius’ friends, friends he’s known for centuries, not to mention hurting you, I hope it’s Octavius that manages to get rid of that blackguard.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where are they now?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“In Europe. Mal’s recovering from the duel; he’s on the run, trying to regain strength. Octavius has engaged some of his best men to follow the scent. They’ll find his weakness; get to him before he gets to you. He told me...” Jaegar gritted his teeth. “He told me to send you his best.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Kalina felt a familiar pang. She knew it was best not to think of Octavius, of the time they had shared, of the impossible love she knew she had to give up, but even with Jaegar holding her in his arms it was hard not to think of the beauty and grandeur of Europe, of those weeks they had shared in Italy and France.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What was it like,” asked Kalina. “Spending time with Octavius as a human – you know, before you became a vampire?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jaegar turned away, fixing his gaze on the curtains in the hotel suite. “The same, really,” he murmured. “Except, without the bloodlust. It was strange, being a human among vampires. I felt the way you must have felt. Like meat. I knew they were Octavius’ men, and I trusted them, but the way they looked at me....I knew what they wanted with me. It was strange. Scary, even.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I guess you know how it feels, huh?” said Kalina. “Remember when we first met – you treated me like prey.” She laughed. “You were such a jerk back then,” she said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Jaegar gave a sheepish nod, his eyes still not meeting her. “I know,” he said. “I still thought all humans were just...prey. And then I met you. And that made all the difference in the world.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0